import gql from "graphql-tag"

const currentUserId = scope => (scope === "currentUser" ? "id" : "")

const RelevantBenchmarkQuery = ({ field, companyIds, scope }) => gql`
query(
  $from: Date!
  $to: Date!
  $settings: BenchmarkInput!
  ${companyIds ? "$companyIds: [Int!]!" : ""}
) {
  ${scope} {
    ${currentUserId(scope)}
    kpis {
      ${field}(
        ${companyIds ? "companyIds: $companyIds" : ""}
        from: $from
        to: $to
      ) {
        benchmark(settings: $settings)
      }
    }
  }
}
`

export default RelevantBenchmarkQuery
